<template>
    <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" max-width="180px">
        <template v-slot:activator="{props}">
            <v-text-field
                ref="input"
                v-model="time"
                :label="label"
                :rules="rules"
                :outlined="outlined"
                :density="density ? density : dense ? 'compact' : 'comfortable'"
                :hide-details="hideDetails"
                :disabled="disabled"
                bg-color="white"
                prepend-icon="mdi-clock"
                :type="type"
                :placeholder="type === 'text' ? '__:__' : ''"
                required
                :clearable="clearable"
                :validate-on="validateOnBlur ? 'blur' : 'submit'"
                :class="contentClass"
                v-bind="props"
                min-width="150"
                @blur="blur"
            />
        </template>
        <time-picker v-model="time" :min="min" :max="max" @update="menu = false" />
    </v-menu>
</template>

<script lang="ts">
    import {Component, Emit, Prop, VModel, Vue, Watch} from 'vue-facing-decorator'
    import TimePicker from '@/components/snippets/forms/TimePicker.vue'
    import Cleave from 'cleave.js'

    //TODO Move TimePicker here and rename this to TimePicker
    @Component({
        components: {TimePicker},
    })
    export class TimeField extends Vue {
        @VModel() time
        @Prop() label
        @Prop() rules
        @Prop({default: false, type: Boolean}) outlined
        @Prop({default: false, type: Boolean}) clearable
        @Prop({default: false, type: Boolean}) dense
        @Prop({default: false, type: Boolean}) hideDetails
        @Prop({default: false, type: Boolean}) disabled
        @Prop({default: false, type: Boolean}) validateOnBlur
        @Prop() min
        @Prop() max
        @Prop({default: 'time', type: String}) type
        @Prop({type: String}) density
        @Prop() contentClass

        menu = false

        @Watch('time')
        onTimeChange(time) {
            this.change(time)
        }

        @Emit()
        change(time) {
            return time
        }

        @Emit()
        blur() {}

        mounted() {
            if (this.type === 'text') {
                // Workaround - $refs.input is undefined by unknown reason
                const input = this.$refs.menu.$el.nextElementSibling.querySelector('input')
                new Cleave(input, {
                    time: true,
                    timePattern: ['h', 'm'],
                })
                input.oninput = e => {
                    this.time = e.target.value
                }
            }
        }
    }

    export default TimeField
</script>
